var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolarisIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4H14C13.447 4 13 4.448 13 5C13 5.552 13.447 6 14 6H16V16H4V4H7.586L9 5.414V10.586L7.707 9.293C7.316 8.902 6.684 8.902 6.293 9.293C5.902 9.684 5.902 10.316 6.293 10.707L9.293 13.707C9.488 13.902 9.744 14 10 14C10.256 14 10.512 13.902 10.707 13.707L13.707 10.707C14.098 10.316 14.098 9.684 13.707 9.293C13.316 8.902 12.684 8.902 12.293 9.293L11 10.586V5C11 4.735 10.895 4.48 10.707 4.293L8.707 2.293C8.52 2.105 8.266 2 8 2H3C2.447 2 2 2.448 2 3V17C2 17.552 2.447 18 3 18H17C17.553 18 18 17.552 18 17V5C18 4.448 17.553 4 17 4Z",
    fill: "#637381"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11593_93690",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4H14C13.447 4 13 4.448 13 5C13 5.552 13.447 6 14 6H16V16H4V4H7.586L9 5.414V10.586L7.707 9.293C7.316 8.902 6.684 8.902 6.293 9.293C5.902 9.684 5.902 10.316 6.293 10.707L9.293 13.707C9.488 13.902 9.744 14 10 14C10.256 14 10.512 13.902 10.707 13.707L13.707 10.707C14.098 10.316 14.098 9.684 13.707 9.293C13.316 8.902 12.684 8.902 12.293 9.293L11 10.586V5C11 4.735 10.895 4.48 10.707 4.293L8.707 2.293C8.52 2.105 8.266 2 8 2H3C2.447 2 2 2.448 2 3V17C2 17.552 2.447 18 3 18H17C17.553 18 18 17.552 18 17V5C18 4.448 17.553 4 17 4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11593_93690)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolarisIcon);
export default __webpack_public_path__ + "static/media/polaris_icon.1aaa56c0.svg";
export { ForwardRef as ReactComponent };